import { useEffect, useState } from 'react'
import { useAuthStore } from '../store/authStore'
import { simpleAuthService } from '../services/simpleAuthService'

export const useAuth = () => {
  const { user, token, isAuthenticated, clearAuth } = useAuthStore()
  const [isLoading, setIsLoading] = useState(true)
  const [isValidating, setIsValidating] = useState(false)

  useEffect(() => {
    const validateAuth = async () => {
      if (!token || !isAuthenticated) {
        setIsLoading(false)
        return
      }

      // Mostrar UI de inmediato si hay usuario cacheado; refrescar rol/datos en segundo plano
      if (user) {
        setIsLoading(false)
      } else {
        setIsValidating(true)
      }

      try {
        const currentUser = await simpleAuthService.getCurrentUser(token)
        useAuthStore.getState().setUser(currentUser)
      } catch (error) {
        console.warn('Token inválido o expirado:', error)
        clearAuth()
      } finally {
        setIsValidating(false)
        setIsLoading(false)
      }
    }

    validateAuth()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refrescar al montar / cambiar token
  }, [token, isAuthenticated, clearAuth])

  return {
    user,
    token,
    isAuthenticated,
    isLoading: isLoading || isValidating,
    isValidating,
  }
}
